import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";
import SuspanceLoading from "./components/SuspanceLoading";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TourProvider } from "./components/ToureStepps/TourProvider";
import { AccessProvider } from "./components/Auth/AccessProvider";
import { SubscriptionProvider } from "./components/Auth/SubscriptionContext";
import { CommonThemeProvider } from "./pages/LawyerPages/Settings/useTheme";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { google_client_id } from "./static/server";
// import { MsalProvider } from "@azure/msal-react";
// import { msalInstance } from "./components/Auth/microsoftAuth";
import { AIActivationProvider } from "./components/AiBotUtils/AIActivationContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={google_client_id}>
      {/* <MsalProvider instance={msalInstance}> */}
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <PersistGate loading={null} persistor={persistor}>
              <Suspense fallback={<SuspanceLoading />}>
                <TourProvider>
                  <CommonThemeProvider>
                    <BrowserRouter>
                      <AccessProvider>
                        {/* <DialogProvider> */}
                        <SubscriptionProvider>
                          <AIActivationProvider>
                            <ToastContainer
                              position="top-right"
                              autoClose={3000}
                              hideProgressBar={false}
                              newestOnTop={false}
                              closeOnClick
                              rtl={false}
                              pauseOnFocusLoss
                              draggable
                              pauseOnHover
                              theme="light"
                              style={{ zIndex: 12000 }}
                            />
                            <App />
                          </AIActivationProvider>
                        </SubscriptionProvider>
                        {/* </DialogProvider> */}
                      </AccessProvider>
                    </BrowserRouter>
                  </CommonThemeProvider>
                </TourProvider>
              </Suspense>
            </PersistGate>
          </LocalizationProvider>
        </Provider>
      {/* </MsalProvider> */}
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
